import axios from 'axios';
import { API_SERVER, API_PORT, API_PATH } from '../config';

const http = axios.create({
  baseURL: `${API_SERVER + (API_PORT ? `:${API_PORT}` : '')}/${API_PATH}`,
});

export default http;
